if (!customElements.get('wishlist-page')) {
  class WishlistPage extends HTMLElement {
    constructor() {
      super();

      this.table = this.querySelector('.gg-wishlist__table');
      this.body = this.table.querySelector('.gg-wishlist__body');
      this.message = this.querySelector('.gg-wishlist__message');
      this.clearButton = this.querySelector('.js-clear-wishlist');
      this.removeButtons = null;
      this.clearModal = document.querySelector('#wishlist-clear-modal');
      
      this.baseUrl = window.theme?.auth?.wishlistBaseUrl || 'https://app.sportsfuel.co.nz/api/wishlist';
      this.wishlistId = null;
      this.wishlistData = {}
      this.wishlist = null

      this.init();
    }

    async init() {
      await this.setWishlistId();
      if (this.wishlistId) {
        this.wishlist = await this.fetchWishlist();
        
        this.dataset.showLoggedOut = false;
        this.bindEvents();
      } else {
        this.dataset.showLoggedOut = true;
      }
      this.dataset.loading = false;
    }

    async setWishlistId() {
      // Check if customer is logged in
      const customerId = window.Shopify?.customer?.id;
      if (customerId) {
        this.wishlistId = customerId;
        return;
      }

      // Check for __sf_id cookie
      const cookies = document.cookie.split(';');
      const sfIdCookie = cookies.find(cookie => cookie.trim().startsWith('__sf_id='));
      
      if (sfIdCookie) {
        try {
          const encodedId = sfIdCookie.split('=')[1];
          this.wishlistId = atob(encodedId);
        } catch (error) {
          console.error('Error decoding wishlist ID:', error);
        }
      }
    }

    async fetchWishlist() {
      try {
        const response = await fetch(`${this.baseUrl}/${this.wishlistId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        });

        if (response.status === 404) {
          return [];
        }

        if (!response.ok) {
          throw new Error('Failed to fetch wishlist');
        }

        const data = await response.json();
        
        if (data.products) {
          this.wishlistData = data.products;
          this.wishlist = await this.fetchProducts(Object.keys(data.products));
          
          if (this.wishlist) {
            this.dataset.count = this.wishlist.length;

            this.body.innerHTML = this.wishlist.map(product => `
              <div class="gg-wishlist__row">
                <div class="gg-wishlist__cell gg-wishlist__cell--product">
                  <div class="gg-wishlist__product">
                    <div class="gg-wishlist__product-image">
                      <a href="/products/${product.handle}" target="_blank">
                        <img src="${product.bundleImage || product.image}" alt="${product.title}" width="100" height="100">
                      </a>
                    </div>
                    <a href="/products/${product.handle}" target="_blank" class="gg-wishlist__product-title">${product.title}</a>
                  </div>
                </div>
                <div class="gg-wishlist__cell gg-wishlist__cell--price">
                  <span class="gg-wishlist__cell--price-from">${product.priceVaries ? 'From' : ''}</span>
                  <span class="gg-wishlist__cell--price-amount">$${product.price}</span>
                  <span class="gg-wishlist__cell--price-compare">${product.compareAtPrice ? `$${product.compareAtPrice}` : ''}</span>
                </div>
                <div class="gg-wishlist__cell gg-wishlist__cell--availability">
                  <div class="pickup-icon">
                    ${product.availableForSale ? `
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m16.558 4.8.884.884-9.959 9.958-4.925-4.925.884-.884 4.041 4.041z"/></svg>
                    ` : `
                      <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M5 19 19 5M5 5l14 14"/></svg>
                    `}
                  </div>
                  <span>${product.availableForSale ? 'In stock' : 'Out of stock'}</span>
                </div>
                <div class="gg-wishlist__cell gg-wishlist__cell--actions">
                  <a href="/products/${product.handle}" target="_blank" class="btn btn--primary">View Product</a>
                  <button class="gg-wishlist__remove" data-product-id="${product.id}">
                    <svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5zm2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5z" fill="currentColor"/></svg>
                  </button>
                </div>
              </div>  
            `).join('')

            this.removeButtons = this.querySelectorAll('.gg-wishlist__remove');
          }
        }
        
      } catch (error) {
        console.error('Error fetching wishlist:', error);
        this.dataset.error = true;
        this.message.innerHTML = 'There was an error fetching your wishlist. If you continue to see this message, please contact us.';
      }
    }

    async fetchProducts(productIds) {
      try {
        const response = await fetch('/api/2025-04/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': window.theme.storefrontAccessToken
          },
          body: JSON.stringify({
            query: `
              query getProducts($ids: [ID!]!) {
                nodes(ids: $ids) {
                  ... on Product {
                    availableForSale
                    id
                    title
                    handle
                    priceRange {
                      maxVariantPrice {
                        amount
                      }
                      minVariantPrice {
                        amount
                      }
                    }
                    compareAtPriceRange {
                      minVariantPrice {
                        amount
                      }
                    }
                    featuredImage {
                      url
                    }
                    bundleImage: metafield(namespace: "global", key: "bundle_image") {
                      value
                    }
                  }
                }
              }
            `,
            variables: {
              ids: productIds.map(id => `gid://shopify/Product/${id}`)
            }
          })
        });

        if (!response.ok) {
          throw new Error('Failed to fetch products');
        }

        const data = await response.json();
        const products = data.data?.nodes?.filter(Boolean) || [];
        
        return products.map(p => {
          const productId = p.id.split('/').pop();
          const price = p.priceRange.minVariantPrice.amount;
          const priceMax = p.priceRange.maxVariantPrice.amount;
          const compareAtPrice = p.compareAtPriceRange?.minVariantPrice?.amount || null;

          return ({
            id: productId,
            addedAt: this.wishlistData[productId] ? this.wishlistData[productId].addedAt : null,
            availableForSale: p.availableForSale,
            bundleImage: p.bundleImage?.value || null,
            compareAtPrice: compareAtPrice && Number(compareAtPrice) > Number(price) ? compareAtPrice : null,
            handle: p.handle,
            image: p.featuredImage?.url || null,
            price: Number(price).toFixed(2),
            priceVaries: priceMax ? Number(price) < Number(priceMax) : false,
            title: p.title,
          })
        });
      } catch (error) {
        console.error('Error fetching products:', error);
        this.dataset.error = true;
        this.message.innerHTML = 'There was an error fetching your wishlist. If you continue to see this message, please contact us.';
      }
    }

    async clearWishlist() {
      try {
        const response = await fetch(`${this.baseUrl}/${this.wishlistId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Failed to clear wishlist');
        }
        
        this.clearModal.close();
        this.clearButton.classList.remove('is-loading');
        this.init();
      } catch (error) {
        console.error('Error clearing wishlist:', error);
        this.dataset.error = true;
        this.message.innerHTML = 'There was an error clearing your wishlist. If you continue to see this message, please contact us.';
      }
    }

    async removeProduct(productId) {
      try {
        const response = await fetch(`${this.baseUrl}/${this.wishlistId}/${productId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Failed to remove product from wishlist');
        }

        this.init();
      } catch (error) {
        console.error('Error removing product from wishlist:', error);
      }
    }

    bindEvents() {
      // Remove product buttons
      this.removeButtons.forEach(button => {
        button.addEventListener('click', async (event) => {
          button.classList.add('is-loading');
          await this.removeProduct(button.dataset.productId);
        });
      });

      this.clearButton.addEventListener('click', () => {
        this.clearButton.classList.add('is-loading');
        this.clearWishlist();
      });
    }
  }

  customElements.define('wishlist-page', WishlistPage);
}